import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const ItemContainer = styled.div``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerItem = styled.div`
  display: flex;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px;
  gap: 10px;
`;

export const TitleWrapperText = styled.span`
  display: flex;
  font-family: Biotif;
  font-weight: Regular;
  font-size: 18px;
  letter-spacing: 0px;
  align-items: center;
  color: #222247;
`;

export const AccountDetailsContainer = styled.div`
  display: flex;
  column-gap: 20px;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const AccountDetailsButtonContainer = styled.div`
  margin-top: 10px;
`;

export const AccessAuthContainer = styled.div`
  display: flex;
  column-gap: 50px;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LastLoginText = styled.span`
  font-size: 16px;
  font-family: Segoe UI;
`;

export const HeaderRightItems = styled.div`
  display: flex;

  align-items: center;
  gap: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: flex-end;
  }
`;

export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;

export const EditIcon = styled.img`
  width: 15px;
`;

export const HeaderLine = styled.div`
  content: '';
  flex: 1;
  height: 1px;
  background-color: #4948ac;
  align-self: center;
`;
